import React, { useCallback, useEffect, useState, Suspense } from "react";
import { Redirect, Route, Switch, useHistory, useLocation } from "react-router-dom";
import { publicRoutes, authRoutes } from "./index";
import { LazyUnauthorized } from "../utils/lazyComponents";
import Header from "../Components/Header/Header";
import SideMenu from "../Components/Header/SideMenu";
import Loading from "../Loading/Loading";

const EnhancedLoading = ({ message = "Loading..." }) => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    flexDirection: 'column',
    fontFamily: 'Montserrat, sans-serif'
  }}>
    <Loading datatable="true" />
    <p style={{ marginTop: '1rem', color: '#666', fontSize: '14px' }}>
      {message}
    </p>
  </div>
);

const AppRoutes = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isSideMenuOpen, setIsSideMenuOpen] = useState(false);
  const [roleId, setRoleId] = useState(null);
  const history = useHistory();
  const location=useLocation()

  useEffect(() => {
    window.addEventListener("storage", function (e) {
      if (e.key === "login") {
        this.window.location.reload();
      }
    });
  }, []);
  useEffect(() => {
    const routesThatKeepSession = ['/addroute', '/addroute-stop'];
    if (!routesThatKeepSession.includes(location.pathname)) {
      const keysToRemove = [
        'routeName', 'routeType', 'shuttleType', 'routeDetails',
        'selectedCorporateId', 'timings', 'routeValue', 'tempRouteData'
      ];
      keysToRemove.forEach(key => sessionStorage.removeItem(key));
    }
  }, [location.pathname]);

  useEffect(() => {
    let status = localStorage.getItem("login");
    if (status === null) setIsLoggedIn(false);
    else status === "false" ? setIsLoggedIn(false) : setIsLoggedIn(true);

    const storedRoleId = localStorage.getItem("roleId");
    setRoleId(storedRoleId);
  }, [history, location.pathname]);

  const loginHandler = useCallback((loggedValue) => {
    localStorage.setItem("login", true);
    history.push("/dashboard");
    setIsLoggedIn(loggedValue);
  }, [history]);

  useEffect(() => {
    if (window.screen.width >= 768) {
      const pathsElement = document.getElementsByClassName("paths")[0];
      if (pathsElement) {
        if (isSideMenuOpen) {
          pathsElement.style.width = "80%";
        } else {
          pathsElement.style.width = "100%";
        }
      }
    }
  }, [isSideMenuOpen]);

  const sideMenuHoverHandler = () => {
    setIsSideMenuOpen(true);
  };

  const sideMenuLeaveHandler = () => {
    setIsSideMenuOpen(false);
  };

  return (
    <div style={{ height: "100%" }}>
      <Suspense fallback={<EnhancedLoading message="Initializing application..." />}>
        <Switch>
          <Route path="/" exact>
            <Redirect to="/login" />
          </Route>
          <Route path="/login">
            {isLoggedIn ? (
              <Redirect to="/dashboard" />
            ) : (
              <Suspense fallback={<EnhancedLoading message="Loading login..." />}>
                {(() => {
                  const loginRoute = publicRoutes.find(route => route.path === "/login");
                  if (loginRoute) {
                    const LoginComponent = loginRoute.component;
                    return <LoginComponent login={loginHandler} />;
                  }
                  return <div>Login not found</div>;
                })()}
              </Suspense>
            )}
          </Route>
          {!isLoggedIn && (
            <Route path="/">
              <Suspense fallback={<EnhancedLoading message="Loading login..." />}>
                {(() => {
                  const loginRoute = publicRoutes.find(route => route.path === "/login");
                  if (loginRoute) {
                    const LoginComponent = loginRoute.component;
                    return <LoginComponent login={loginHandler} />;
                  }
                  return <div>Login not found</div>;
                })()}
              </Suspense>
            </Route>
          )}
        </Switch>
        {isLoggedIn && (
          <React.Fragment>
            <Header
              sideMenuOpen={sideMenuHoverHandler}
              setIsLoggedIn={setIsLoggedIn}
            />
            <div className="myContainer">
              <SideMenu
                sideMenuClose={sideMenuLeaveHandler}
                property={isSideMenuOpen}
              />
              <div className="paths">
                <Switch>
                  {publicRoutes?.map((route, idx) => (
                    <Route key={idx} path={route.path} exact={route.exact}>
                      <Suspense fallback={<EnhancedLoading message={`Loading ${route.path.replace('/', '')}...`} />}>
                        <route.component setIsLoggedIn={setIsLoggedIn} />
                      </Suspense>
                    </Route>
                  ))}
                  {authRoutes?.map((route, idx) => (
                    <Route key={idx} path={route.path}>
                      <Suspense fallback={<EnhancedLoading message={`Loading ${route.path.split('/').pop()}...`} />}>
                        {(route.path === "/new-registration" ||
                          route.path === "/settings" ||
                          route.path === "/addpricing" ||
                          route.path === "/corporates") &&
                        roleId !== "1" ? (
                          <LazyUnauthorized />
                        ) : (
                          <route.component />
                        )}
                      </Suspense>
                    </Route>
                  ))}
                </Switch>
              </div>
            </div>
          </React.Fragment>
        )}
      </Suspense>
    </div>
  );
};

export default AppRoutes;
